import { render } from "./user.vue?vue&type=template&id=449e2766&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=449e2766&scoped=true&lang=css"
import "./user.vue?vue&type=style&index=1&id=449e2766&lang=css"
script.render = render
script.__scopeId = "data-v-449e2766"

export default script